import { AssistantDocsSiteSources, CoursesDocsSiteSources } from './DocsSiteSource';
import LoggedPage from './LoggedPage';

const LoggedPageSources = {
  // ensure that for each logged page source, sources are logged at entry point enter
  // via usePageLogs#logEnterEntryPoint
  [LoggedPage.Assistant]: AssistantDocsSiteSources,
  [LoggedPage.Courses]: CoursesDocsSiteSources,
};

export default LoggedPageSources;
